import './FeesPage.css';
import Table from 'react-bootstrap/Table';

function FeesPage() {
  return (
    <div className="fees-page">
      <div className="membership-fees-section">
        <h1>Mitgliedsbeiträge</h1>
        <p>
          <i>Stand Februar 2025</i>
        </p>
        <Table bordered hover responsive className="fees-table">
          <thead>
            <tr>
              <th></th>
              <th>Einmalige Aufnahmegebühr</th>
              <th>Jahres-Mitgliedsbeitrag</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Familien <br />
                <span>(Kinder bis 18 Jahre*)</span>
              </td>
              <td>55,00 €</td>
              <td>110,00 €</td>
            </tr>
            <tr>
              <td>Erwachsene</td>
              <td>45,00 €</td>
              <td>85,00 €</td>
            </tr>
            <tr>
              <td>
                Jugendliche
                <br />
                <span>(14 - 18 Jahre*)</span>
              </td>
              <td>15,00 €</td>
              <td>55,00 €</td>
            </tr>
            <tr>
              <td>
                Kinder
                <br />
                <span>(unter 14 Jahre)</span>
              </td>
              <td>keine</td>
              <td>25,00 €</td>
            </tr>
            <tr>
              <td colSpan={3}>
                *Ab 18 Jahren muss jährlich <i>(bis zum 31.01.)</i> ein Nachweis
                beim Vorstand vorgelegt werden über eine schulische Ausbildung,
                Berufsausbildung oder ein aktives Studium. Mit Nachweis ist der
                Beitrag ermäßigt bis zum Alter von 27 Jahren, danach{' '}
                <i>(oder bei fehlendem Nachweis)</i> erfolgt automatisch der
                Wechsel in die erwachsenen Mitgliedschaft.
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div className="rental-fees-section">
        <h1>Leihgebühren</h1>
        <h3>Mitglieder</h3>
        <Table bordered hover responsive className="rental-fees-table">
          <thead>
            <tr>
              <th></th>
              <th>pro Tag</th>
              <th>pro Woche</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Kajak mit Doppelpaddel und Spritzdecke</td>
              <td>5,00€</td>
              <td>20,00€</td>
            </tr>
            <tr>
              <td>Kanadier mit Stechpaddeln</td>
              <td>7,50€</td>
              <td>30,00€</td>
            </tr>
            <tr>
              <td>KFZ - Bootsanhänger</td>
              <td>10,00€</td>
              <td>40,00€</td>
            </tr>
            <tr>
              <td>Stech- oder Doppelpaddel</td>
              <td>1,00€</td>
              <td>4,00€</td>
            </tr>
            <tr>
              <td>Helm</td>
              <td>1,00€</td>
              <td>4,00€</td>
            </tr>
            <tr>
              <td>Schwimmweste/-hilfe</td>
              <td>1,00€</td>
              <td>4,00€</td>
            </tr>
            <tr>
              <td>Neoprenanzug*</td>
              <td>1,00€</td>
              <td>7,00€</td>
            </tr>
            <tr>
              <td colSpan={3}>
                *Für Kinder und jugendliche Vereinsmitglieder ist das Ausleihen
                von Material frei. Ausgenommen ist das Ausleihen von
                Neoprenanzügen.
              </td>
            </tr>
          </tbody>
        </Table>
        <h3>Nicht Mitglieder</h3>
        <Table bordered hover responsive className="rental-fees-table">
          <thead>
            <tr>
              <th></th>
              <th>pro Tag</th>
              <th>pro Woche</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Kajak mit Doppelpaddel und Spritzdecke</td>
              <td>10,00€</td>
              <td>40,00€</td>
            </tr>
            <tr>
              <td>Kanadier mit Stechpaddeln</td>
              <td>13,50€</td>
              <td>50,00€</td>
            </tr>
            <tr>
              <td>KFZ - Bootsanhänger</td>
              <td>20,00€</td>
              <td>80,00€</td>
            </tr>
            <tr>
              <td>Stech- oder Doppelpaddel</td>
              <td>1,50€</td>
              <td>6,00€</td>
            </tr>
            <tr>
              <td>Helm</td>
              <td>1,50€</td>
              <td>6,00€</td>
            </tr>
            <tr>
              <td>Schwimmweste/-hilfe</td>
              <td>1,50€</td>
              <td>6,00€</td>
            </tr>
            <tr>
              <td>Neoprenanzug</td>
              <td>2,00€</td>
              <td>14,00€</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default FeesPage;
